export const testGroupDomains = [
  'www.alphaagilaunit.com',
  'www.en.kangensports.com',
  'www.erantemplates.com',
  'www.storyloot.com',
  'it.zero-to-superhero.com',
  'www.yikingbusiness.com',
]
